"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("title", null, "Trace Icons_1-3"), /*#__PURE__*/_react["default"].createElement("polygon", {
  points: "13.4 11 10.8 15.5 13.4 20 18.6 20 21.2 15.5 18.6 11 13.4 11"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M30.08,15.21C27.18,9.44,21.79,5.85,16,5.85S4.82,9.44,1.92,15.21a.66.66,0,0,0,0,.58c2.9,5.77,8.29,9.36,14.08,9.36s11.18-3.59,14.08-9.36A.66.66,0,0,0,30.08,15.21ZM16,23.85c-5.19,0-10.06-3.19-12.77-8.35C5.94,10.34,10.81,7.15,16,7.15s10.06,3.19,12.77,8.35C26.06,20.66,21.19,23.85,16,23.85Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M21.18,27.45l.44,1.22a19.45,19.45,0,0,0,8-5.54l-1-.86A18.23,18.23,0,0,1,21.18,27.45Z"
})));
module.exports = exports.default;